module.exports = __webpack_public_path__ + "media/icons/dollar-sign-d0273798.png";